import { Theme } from '@mui/material/styles';
import { buildTheme, ThemeMode } from './buildTheme';
import { DARK_TONES, SIDEBAR_TONE } from './refinedDark';

/**
 * The sidebar in light mode: a soft cool white beside the white pages, edged
 * by a hairline. Where you are is raised as a white chip. Every light-sidebar
 * colour comes from this block; the dark sidebar comes from `SIDEBAR_TONE`.
 */
export const LIGHT_RAIL = {
  surface: '#f6f7f9',
  border: 'rgba(15, 23, 42, 0.08)',
  text: { primary: '#111827', secondary: '#5b6472', disabled: '#9aa2ae' },
  /** The chip under the current page and the search box. */
  raised: '#ffffff',
  raisedShadow: '0 1px 2px rgba(15, 23, 42, 0.06), 0 0 0 1px rgba(15, 23, 42, 0.06)',
};

const DARK_RAIL_THEME = buildTheme('dark', SIDEBAR_TONE, {
  background: { paper: DARK_TONES[SIDEBAR_TONE].rail, default: DARK_TONES[SIDEBAR_TONE].rail },
});

const LIGHT_RAIL_THEME = buildTheme('light', undefined, {
  background: { paper: LIGHT_RAIL.surface, default: LIGHT_RAIL.surface },
  text: LIGHT_RAIL.text,
  divider: LIGHT_RAIL.border,
});

/** The sidebar's theme: light beside light pages, the navy rail in dark mode. */
export const railTheme = (mode: ThemeMode): Theme => (mode === 'dark' ? DARK_RAIL_THEME : LIGHT_RAIL_THEME);
